var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "parallax-image__scroll" }, [
    _c("div", { staticClass: "parallax-image__wrapper" }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            staticClass: "parallax-image row",
            attrs: {
              "data-rellax": "",
              "data-rellax-speed": _vm.parallaxFirstImage
            }
          },
          [
            _c(
              "div",
              { staticClass: "col-9 md:col-7" },
              [_vm._t("first-image")],
              2
            )
          ]
        ),
        _c(
          "div",
          {
            staticClass: "parallax-image row justify-end",
            attrs: {
              "data-rellax": "",
              "data-rellax-speed": _vm.parallaxSecondImage
            }
          },
          [
            _c(
              "div",
              { staticClass: "col-9 md:col-7" },
              [_vm._t("second-image")],
              2
            )
          ]
        )
      ]),
      _c(
        "div",
        { staticClass: "parallax-image__title", class: _vm.classAnimation },
        [_c("div", { staticClass: "container" }, [_vm._t("title")], 2)]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }